import { Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { VehicleKind } from '../../../../api/types';
import VehicleSelectField from '../../../../components/fields/VehicleSelectField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import useVehicleBodyTypeOptions from '../../../../utilities/useVehicleBodyTypeOptions';

export type AddModelDetailsProps = {
    updated?: string;
    offset?: string;
    disabled?: boolean;
};

const colSpan = { lg: 8, md: 12, xs: 24 };

const AddModelDetails = ({ updated, offset, disabled = false }: AddModelDetailsProps) => {
    const { t } = useTranslation('model');
    const { yesNoSwitch } = useSystemSwitchData();

    const bodyTypeOptions = useVehicleBodyTypeOptions();

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <CollapsibleWrapper defaultActiveKey={t('model:cardTitles.mainDetails')}>
                <Panel key={t('model:cardTitles.mainDetails')} header={t('model:cardTitles.mainDetails')}>
                    <Row gutter={14}>
                        <Col {...colSpan}>
                            <VehicleSelectField
                                {...t('model:fields.make', { returnObjects: true })}
                                autoSelected={!updated}
                                disabled={disabled}
                                name="makeId"
                                vehicleKind={VehicleKind.LocalMake}
                                required
                            />
                        </Col>
                        <Col {...colSpan}>
                            <FormFields.TranslatedInputField
                                {...t('model:fields.name', { returnObjects: true })}
                                disabled={disabled}
                                name="name"
                                required
                            />
                        </Col>
                        <Col {...colSpan}>
                            <FormFields.InputField
                                {...t('model:fields.identifier', { returnObjects: true })}
                                disabled={disabled}
                                name="identifier"
                                required
                            />
                        </Col>
                        <Col {...colSpan}>
                            <FormFields.SelectField
                                {...t('model:fields.bodyType', { returnObjects: true })}
                                disabled={disabled}
                                name="bodyType"
                                options={bodyTypeOptions}
                                required
                                showSearch
                            />
                        </Col>
                        <Col {...colSpan}>
                            <FormFields.InputNumberField
                                {...t('model:fields.order', { returnObjects: true })}
                                disabled={disabled}
                                min={1}
                                name="order"
                                required
                            />
                        </Col>
                        <Col {...colSpan}>
                            <FormFields.SwitchField
                                {...t('model:fields.isActive', { returnObjects: true })}
                                disabled={disabled}
                                name="isActive"
                                {...yesNoSwitch}
                                required
                            />
                        </Col>
                        {updated && (
                            <Col {...colSpan}>
                                <FormFields.DisplayFieldWithUTCOffset
                                    {...t('common:fields.updated', { returnObjects: true, offset })}
                                    value={updated}
                                />
                            </Col>
                        )}
                    </Row>
                </Panel>
            </CollapsibleWrapper>
        </Space>
    );
};

export default AddModelDetails;
